// extracted by mini-css-extract-plugin
export default {"contents":"gG-z","sectionHeading":"hG-z"};